// project import
//import dashboard from './dashboard';
import realtime from './realtime';
import report from './report';
import record from './record';
import onm from './onm';
import admin from './admin';
import outeradmin from './outeradmin';
import control from './control';
// import pages from './page';
// import utilities from './utilities';
// import support from './support';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [realtime, record, report, control, onm, admin, outeradmin]
};

export default menuItems;
